__turbopack_context__.v({
  "benefit": "BuySection-module__-_2MBq__benefit",
  "benefits-container": "BuySection-module__-_2MBq__benefits-container",
  "billed-at": "BuySection-module__-_2MBq__billed-at",
  "caption": "BuySection-module__-_2MBq__caption",
  "card-header": "BuySection-module__-_2MBq__card-header",
  "cta": "BuySection-module__-_2MBq__cta",
  "cta-container": "BuySection-module__-_2MBq__cta-container",
  "disclaimer": "BuySection-module__-_2MBq__disclaimer",
  "numbered-disclaimers": "BuySection-module__-_2MBq__numbered-disclaimers",
  "price": "BuySection-module__-_2MBq__price",
  "primary": "BuySection-module__-_2MBq__primary",
  "productCard": "BuySection-module__-_2MBq__productCard",
  "root": "BuySection-module__-_2MBq__root" + " " + __turbopack_context__.i(905307)["sectionPadding"],
  "row": "BuySection-module__-_2MBq__row",
  "save-tag": "BuySection-module__-_2MBq__save-tag",
  "state-icon": "BuySection-module__-_2MBq__state-icon",
});
